import { API_BASE_URL } from "../../constant/constant";
import React, { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  Container,
  Form,
  LoginBox,
  Title,
  Input,
  InputLabel,
  FormText,
  SignInButton,
  ContentDiv,
  LogoBox,
  PasswordWrapper,
} from "./Style";
import SnackbarAlert from "../../Components/Alerts/SnackbarAlert";
import CircularProgress from "@mui/material/CircularProgress";
import Logo from "../../assets/Logo.png";
import VerificationModal from "./VerificationModal";
import ShowPassword from "../../assets/show-password.svg";

const Signup = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company_name: "",
    password: "",
  });
  const [isModalOpen, setModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [userEmail, setUserEmail] = useState(""); // New state for storing user email
  const [showPassword, setShowPassword] = useState(false);
  const [formErrors, setFormErrors] = useState({}); // Add this new state
  const navigate = useNavigate();
  const [searchParams] = useSearchParams(); // Add this to get URL parameters
  const { t } = useTranslation();

  useEffect(() => {
    // Check if user info is already stored in local storage
    const email = localStorage.getItem("email");
    const password = localStorage.getItem("password");
    if (email && password) {
      navigate("/");
    }
  }, [navigate]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Add validation check
    const errors = {};
    if (!formData.name.trim()) errors.name = t("auth.signup.errors.nameRequired");
    if (!formData.email.trim()) errors.email = t("auth.signup.errors.emailRequired");
    if (!formData.password.trim()) errors.password = t("auth.signup.errors.passwordRequired");

    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      setSnackbarMessage(t("auth.signup.errors.fillAllFields"));
      setSnackbarOpen(true);
      return;
    }

    setLoading(true);

    try {
      // Get the src parameter from URL
      const src = searchParams.get('src');

      // Create the payload with src included if it exists
      const payload = { ...formData };
      if (src) {
        payload.src = src;
      }

      const response = await fetch(
        // `${API_BASE_URL}/api/auth/register`,
        `${API_BASE_URL}/api/auth/register`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload), // Use payload instead of formData
        }
      );

      const data = await response.json();
      if (!response.ok) {
        setSnackbarMessage(data.msg || t("auth.signup.errors.networkError"));
        setSnackbarOpen(true);
        return
      }

      const secondResponse = await fetch("https://api.emailflowpro.aivoria.nl/api/user/signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!secondResponse.ok) {
        throw new Error("Second API call failed");
      }

      const secondData = await secondResponse.json();
      console.log("Second API call successful:", secondData);


      // Assuming the response contains a success message or data
      console.log(data.user.email);
      //localStorage.setItem("email", data.user.email);
      setUserEmail(data.user.email);//set email in state to be used for resend 
      // console.log("Registration successful:", data);
      setSnackbarMessage(t("auth.signup.messages.signupSuccess"));
      setSnackbarOpen(true);
      setModalOpen(true);

    } catch (error) {
      console.log(error);

    } finally {
      setLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };
  return (
    <>
      <VerificationModal modalIsOpen={isModalOpen} closeModal={() => { setModalOpen(false) }} email={userEmail} />
      <Container>
        <LoginBox style={{ height: '90%' }}>
          <ContentDiv>
            <LogoBox>
              <img
                src={Logo}
                alt="logo"
                style={{
                  height: "5.5875rem",
                  width: "auto",
                  objectFit: "contain"
                }}
              />
            </LogoBox>
            <Title>{t("auth.signup.title")}</Title>
            <Form>
              <InputLabel>{t("auth.signup.nameLabel")}</InputLabel>
              <Input
                type="text"
                name="name"
                placeholder={t("auth.signup.namePlaceholder")}
                value={formData.name}
                onChange={handleChange}
                required
                style={{
                  borderColor: formErrors.name ? '#ff0000' : '1px solid #ebebfd',
                }}
              />
              <InputLabel style={{ marginTop: "0.655rem" }}>{t("auth.signup.emailLabel")}</InputLabel>
              <Input
                type="email"
                name="email"
                placeholder={t("auth.signup.emailPlaceholder")}
                value={formData.email}
                onChange={handleChange}
                required
                style={{
                  borderColor: formErrors.email ? '#ff0000' : '1px solid #ebebfd',
                }}
              />
              <InputLabel style={{ marginTop: "0.655rem" }}>
                {t("auth.signup.companyLabel")}
              </InputLabel>
              <Input
                type="text"
                name="company_name"
                placeholder={t("auth.signup.companyPlaceholder")}
                value={formData.company_name}
                onChange={handleChange}
              />
              <InputLabel style={{ marginTop: "0.655rem" }}>{t("auth.signup.passwordLabel")}</InputLabel>
              <PasswordWrapper>
                <Input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder={t("auth.signup.passwordPlaceholder")}
                  style={{
                    width: "100%",
                    borderColor: formErrors.password ? '#ff0000' : '1px solid #ebebfd',
                  }}
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
                <img
                  src={ShowPassword}
                  alt={t("auth.signup.altTogglePassword")}
                  onClick={() => setShowPassword(!showPassword)}
                  style={{
                    position: "absolute",
                    cursor: "pointer",
                    width: "1.5rem",
                    height: "1.5rem",
                    opacity: "0.7",
                    right: "1rem",
                  }}
                />
              </PasswordWrapper>
              {/* <FormText
                style={{ marginLeft: "auto", marginTop: "0.69rem" }}
                onClick={() => navigate("/forgotpassword")}
                onMouseOver={(e) =>
                  (e.currentTarget.style.textDecoration = "underline")
                }
                onMouseOut={(e) =>
                  (e.currentTarget.style.textDecoration = "none")
                }
              >
                Forgot password?
              </FormText> */}
              {/* <SignInButton type="submit" onClick={handleSubmit}> */}
              <SignInButton
                type="submit"
                onClick={handleSubmit}
                disabled={loading}
              >
                {loading ? (
                  <CircularProgress size={21} color="inherit" />
                ) : (
                  t("auth.signup.button")
                )}
              </SignInButton>
            </Form>
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FormText>
                {t("auth.signup.alreadyHaveAccount")}
                <span
                  style={{ color: "#51307F", cursor: "pointer" }}
                  onClick={() => navigate("/login")}
                  onMouseOver={(e) =>
                    (e.currentTarget.style.textDecoration = "underline")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.style.textDecoration = "none")
                  }
                >
                  {t("auth.signup.signIn")}
                </span>
              </FormText>
            </div>
          </ContentDiv>
        </LoginBox>
        <SnackbarAlert
          open={snackbarOpen}
          setOpen={setSnackbarOpen}
          message={snackbarMessage}
          severity={snackbarMessage === t("auth.signup.messages.signupSuccess") ? "success" : "error"}
          autoHideDuration={3000} // Adjust as needed
          onClose={handleCloseSnackbar}
        />
      </Container>
    </>
  );
};

export default Signup;